import React from 'react'
import { isMobile, l, SectionMessage } from '@manychat/manyui'

export const MobileWarning = () => {
  if (!isMobile) {
    return null
  }

  return (
    <SectionMessage
      className="m-b"
      variant="warning"
      title={l.translate('Warning!')}
      description={l.translate(
        'Unfortunately, only Inbox is optimized for mobile devices at the moment. Please use a desktop version for everything else. ',
      )}
    />
  )
}
